export default __webpack_public_path__ + "static/media/fruit29.5cf7dcac.jpg";